import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { applicationHistory } from '../../common/application-history';

import { clearSelectedDiscItems,
    enableDiscItemSelectionMode,
    disableDiscItemSelectionMode,
    enableDiscItemArrangeMode,
    disableDiscItemArrangeMode } from '../../disc/actions/disc-actions';

class DiscItemViewHeader extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.handleBackArrow = this.handleBackArrow.bind(this);
    }

    handleBackArrow(){
        const { clearSelectedDiscItems } = this.props;
        clearSelectedDiscItems();
        disableDiscItemArrangeMode();
        var historyState = window.history;
        applicationHistory.goBack();
    }

    render() {
        const { disableDiscItemSelectionMode, clearSelectedDiscItems, enableDiscItemSelectionMode,enableDiscItemArrangeMode,disableDiscItemArrangeMode, disc } = this.props;

        return (
            <header className="header-flex-container">
                <div className="header-flex-left">
                    <div
                        className="header-item-left nav-detail-top-back header-back-button"
                        onClick={this.handleBackArrow}
                    />
                </div>
                <div className="header-flex-right">
                    <div className="header-flex-spacer" />
                    {disc && disc.numItems > 0 && disc.finalizedYn === "N" &&
                    <div
                        className="header-item header-item-right"
                        onClick={() => {
                            enableDiscItemArrangeMode();
                            applicationHistory.push(`${applicationHistory.location.pathname}/arrange`);
                        }}>
                        <div className="header-icon arrange"/>
                        <div className="header-label">Arrange</div>
                    </div>
                    }
                    {disc && disc.numItems > 0 && disc.finalizedYn === "N" &&
                    <div
                        className="header-item header-item-right"
                        onClick={() => {
                            enableDiscItemSelectionMode();
                            applicationHistory.push(`${applicationHistory.location.pathname}/select`);
                        }}>
                        <div className="header-icon select-white"/>
                        <div className="header-label">Select</div>
                    </div>
                    }
                </div>

            </header>
        );
    }
}

DiscItemViewHeader.propTypes = {
    enableDiscItemSelectionMode: PropTypes.func,
    disableDiscItemSelectionMode: PropTypes.func,
    clearSelectedDiscItems: PropTypes.func,
    disc: PropTypes.object,
};

const mapStateToProps = state => {
    return {
        disc: state.disc.selectedDiscDetail
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearSelectedDiscItems: () => dispatch(clearSelectedDiscItems()),
        enableDiscItemSelectionMode: () => dispatch(enableDiscItemSelectionMode()),
        disableDiscItemSelectionMode: () => dispatch(disableDiscItemSelectionMode()),
        disableDiscItemArrangeMode: () => dispatch(disableDiscItemArrangeMode()),
        enableDiscItemArrangeMode: () => dispatch(enableDiscItemArrangeMode())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscItemViewHeader);



// WEBPACK FOOTER //
// ./src/header/components/disc-item-view-header.jsx